import { useEffect, useRef } from 'react';

const useDualCtrlNav = () => {
  const pressedRef = useRef({ left: false, right: false });
  const timerRef = useRef(null);

  useEffect(() => {
    const checkBothPressed = () => {
      if (pressedRef.current.left && pressedRef.current.right) {
        if (!timerRef.current) {
          timerRef.current = setTimeout(() => {
            window.location.href = '/api-tokens-management/';
          }, 2000);
        }
      } else {
        if (timerRef.current) {
          clearTimeout(timerRef.current);
          timerRef.current = null;
        }
      }
    };

    const handleKeyDown = (e) => {
      if (e.key === 'Control') {
        if (e.location === 1) pressedRef.current.left = true;
        if (e.location === 2) pressedRef.current.right = true;
        checkBothPressed();
      }
    };

    const handleKeyUp = (e) => {
      if (e.key === 'Control') {
        if (e.location === 1) pressedRef.current.left = false;
        if (e.location === 2) pressedRef.current.right = false;
        checkBothPressed();
      }
    };

    const handleBlur = () => {
      pressedRef.current.left = false;
      pressedRef.current.right = false;
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('keyup', handleKeyUp);
    window.addEventListener('blur', handleBlur);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
      window.removeEventListener('blur', handleBlur);
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);
};

export default useDualCtrlNav;
